import { createEffect } from "solid-js";
import { orgSwitchEpoch } from "@/features/organizations/active-org";

/**
 * Guard de AISLAMIENTO multi-organización para punteros de entidad abierta.
 *
 * Las rutas del WMS deep-linkean la entidad abierta en la URL (`?picking=`,
 * `?po=`, `?count=`, `?bom=`, `?return=`, `?product=`). Ese puntero es GLOBAL a
 * la ruta, pero la entidad pertenece a UNA organización. El caché local de
 * PowerSync contiene los datos de TODAS mis orgs a la vez (`inventory_org`:
 * `organization_id IN my_org_ids`), así que tras cambiar de empresa en el
 * switcher ese puntero resolvería —o el formulario pre-cargaría— una entidad de
 * la organización ANTERIOR (fuga entre empresas). Al cambiar de org lo
 * descartamos (mismo criterio que el guard del ticket activo del POS de
 * comandero).
 *
 * Observa `orgSwitchEpoch` (que solo sube ante un cambio EXPLÍCITO de org), no
 * el scope directamente: así el asentamiento del scope en el boot
 * (visitante→usuario real, sync tardío de orgs) NO borra un deep-link legítimo
 * recién abierto.
 */
export function useResetOnOrgSwitch(reset: () => void): void {
  let first = true;
  createEffect(() => {
    orgSwitchEpoch(); // rastrea el epoch de cambio explícito
    if (first) {
      first = false;
      return;
    }
    // El `reset` de varias rutas NAVEGA (`?picking=`/`?po=`… → URL limpia). Si se
    // ejecuta SÍNCRONO dentro del flush reactivo del cambio de org, esa navegación
    // re-entra en la misma actualización mientras todas las queries del WMS se
    // re-suscriben por el nuevo `orgId` → cascada que CONGELA la pestaña (evaluado
    // empíricamente en /operations). Lo diferimos fuera del flush: el puntero se
    // descarta igual (mismo tick de microtask), sin re-entrancy.
    queueMicrotask(reset);
  });
}
